if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        const uniqueId = this.dataset.sectionId || Math.random().toString(36).substring(7); // Get an ID for easier log tracking
        console.log(`ProductForm [${uniqueId}] CONSTRUCTOR called for:`, this);

        this.form = this.querySelector('form');
        if (!this.form) {
          console.error(`ProductForm [${uniqueId}]: No form found inside me!`, this);
          return;
        }
        console.log(`ProductForm [${uniqueId}]: Form found:`, this.form);

        const variantIdInput = this.form.querySelector('[name=id]');
        if (variantIdInput) {
            variantIdInput.disabled = false;
        } else {
            console.warn(`ProductForm [${uniqueId}]: Variant ID input not found in form.`, this.form);
        }

        // Attempt to find cart drawer/notification
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        console.log(`ProductForm [${uniqueId}]: this.cart resolved to:`, this.cart); // VERY IMPORTANT LOG

        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) {
            console.error(`ProductForm [${uniqueId}]: No submit button found inside me!`, this);
            return;
        }
        console.log(`ProductForm [${uniqueId}]: Submit button found:`, this.submitButton);

        this.submitButtonText = this.submitButton.querySelector('span'); // Or '.quick-add__submit-text'
        if (!this.submitButtonText) {
            console.warn(`ProductForm [${uniqueId}]: Submit button text span not found.`);
        }


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';

        // Add event listener last, after all properties are set
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        console.log(`ProductForm [${uniqueId}]: Submit event listener ADDED.`);
      }

      onSubmitHandler(evt) {
        const uniqueId = this.dataset.sectionId || "unknown-product-form";
        console.log(`ProductForm [${uniqueId}] ONSUBMIT called. this.cart is:`, this.cart, "Event defaultPrevented BEFORE:", evt.defaultPrevented);

        evt.preventDefault();
        console.log(`ProductForm [${uniqueId}] ONSUBMIT: evt.preventDefault() CALLED. Event defaultPrevented AFTER:`, evt.defaultPrevented);

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
            console.log(`ProductForm [${uniqueId}] ONSUBMIT: Submit button is disabled, returning.`);
            return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner'); // Ensure this selector is correct
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');


        const config = fetchConfig('javascript'); // Ensure fetchConfig is globally available
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Critical check for this.cart
        if (this.cart) {
          console.log(`ProductForm [${uniqueId}] ONSUBMIT: this.cart FOUND. Preparing AJAX sections.`);
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        } else {
          // This is the redirect path!
          console.error(`ProductForm [${uniqueId}] ONSUBMIT: this.cart is NOT FOUND. Redirecting to cart page.`);
          window.location = window.routes.cart_url;
          return;
        }
        config.body = formData;

        console.log(`ProductForm [${uniqueId}] ONSUBMIT: Fetching ${routes.cart_add_url}`);
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log(`ProductForm [${uniqueId}] ONSUBMIT: Fetch response:`, response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            };

            if (this.cart && typeof this.cart.open === 'function') {
              console.log("ProductForm: Explicitly opening cart drawer.");
              // Optional: Add a small delay if needed for rendering to settle
              setTimeout(() => { this.cart.open(); }, 50);
            }
          })
          .catch((e) => {
            console.error(e);
            console.error(`ProductForm [${uniqueId}] ONSUBMIT: Fetch error:`, e);

          })
          .finally(() => {
            console.log(`ProductForm [${uniqueId}] ONSUBMIT: Fetch finally.`);
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');


            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
